<!--工作室详情-->
<template>
    <div class="top-container">
        <el-scrollbar class="second-container">
            <div class="nav_container">
                <div class="nav-box">
                    <ul>
                        <li><a @click="changeActiveNum(0)" :class="activeNum===0?'is_active':''">首页</a></li>
                        <li><a @click="changeActiveNum(1)" :class="activeNum===1?'is_active':''">简介</a></li>
<!--                        <li><a @click="changeActiveNum(2)" :class="activeNum===2?'is_active':''">公告资讯</a></li>-->
                        <li><a @click="changeActiveNum(3)" :class="activeNum===3?'is_active':''">成果展示</a></li>
                        <li><a @click="changeActiveNum(4)" :class="activeNum===4?'is_active':''">教师文章</a></li>
                        <li><a @click="changeActiveNum(5)" :class="activeNum===5?'is_active':''">高水平示范课</a></li>
                        <li><a @click="changeActiveNum(7)" :class="activeNum===7?'is_active':''">区本课程</a></li>
                        <li><a @click="changeActiveNum(8)" :class="activeNum===8?'is_active':''">校本课程</a></li>
                        <li><a @click="changeActiveNum(6)" :class="activeNum===6?'is_active':''">工作日志</a></li>
                    </ul>
                </div>
            </div>


            <div class="info-container">
                <!-- 工作室简介、排行 -->
                <div class="left-container">
                    <!--工作室数据-->
                    <div class="studio-stats-container">
                        <div class="title-box100">
                            <div class="title-name100 title-active">工作室信息</div>
                        </div>
                        <div class="studio-info">
                            <div class="studio-img">
                                <img class="studio-img-img" :src="groupInfo.groupAvatar" alt>
                            </div>
                            <div class="studio-name-care">
                                <div class="studio-name">{{ groupInfo.groupName }}</div>
                                <div class="studio-care-btn"  @click="getStudioCareOrCancel">
                                    {{ groupInfo.isCare === 1 ? '取消关注' : '关注' }}
                                </div>
                                <div class="studio-care-num"><span>{{ groupInfo.careNum }}</span>人关注</div>
                            </div>
                        </div>
                        <div class="studio-stats">
                            <div class="status-item" @click="changeActiveNum(99)">
                                <div class="status-item-num text1">{{ groupInfo.memberNum }}</div>
                                <div class="status-item-name" >成员</div>
                            </div>
                            <div class="status-item" @click="changeActiveNum(3)">
                                <div class="status-item-num text2">{{ groupInfo.achieveNum }}</div>
                                <div class="status-item-name" >成果</div>
                            </div>
                            <div class="status-item" @click="changeActiveNum(6)">
                                <div class="status-item-num text3">{{ groupInfo.logNum }}</div>
                                <div class="status-item-name">日志</div>
                            </div>
                            <div class="status-item" @click="changeActiveNum(4)">
                                <div class="status-item-num text4">{{ groupInfo.articleNum }}</div>
                                <div class="status-item-name" >文章</div>
                            </div>
                            <div class="status-item" @click="changeActiveNum(5)">
                                <div class="status-item-num text5">{{ groupInfo.courseNum }}</div>
                                <div class="status-item-name">示范课</div>
                            </div>
                        </div>
                    </div>
                    <!--工作室数据-->
                    <div class="studio-recommend-container">
                        <div class="title-box100">
                            <div class="title-name100 title-active">名师工作室推荐</div>
                        </div>
                        <div class="studio-care-list">
                            <div class="studio-care-rank" v-for="(item,index)  in studioList.slice(0,20)" :key="item" @click="viewStudio(item)">
                                <div :id="'num' + (index + 1)" class="group-active-index">{{index+1}}</div>
                                <div class="group-active-name">{{item.groupName}}</div>
                                <div class="group-active-care">
                                    <span style="color:red;">{{item.careNum}}</span>人关注
                                </div>
                            </div>
                            <data-empty v-if="studioList&&studioList.length===0" title="暂无数据"/>
                        </div>
                    </div>
                </div>
                <!-- 工作室内容 -->
                <div class="right-container">
                    <div class="right-content">
                        <!--简介-->
                        <div class="right-item-container" v-if="activeNum===99">
                            <div class="title-box">
                                <div class="title-name title-active">工作室成员</div>
                            </div>
                            <div class="studio-member">
                                <div class="member-item" v-for="item in memberList" :key="item">
                                    <div class="member-head">
                                        <img  @error="showDefaultImage(this)" :src="item.memberAvatar" alt/>
                                    </div>
                                    <div class="member-name-role">
                                        <div class="member-role">
                                            {{ item.memberRole === 0 ? '主持人' : item.memberRole === 1 ? '管理' : '成员' }}
                                        </div>
                                        <div class="member-name">
                                            {{ item.memberName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="right-item-container" v-if="activeNum===1">
                            <div class="title-box">
                                <div class="title-name title-active">工作室简介</div>
                            </div>
                            <div class="studio-intro">
                                {{ groupInfo.groupIntroduce }}
                            </div>
                        </div>
                        <!--资讯-->
                        <div class="right-item-container" v-if="activeNum===0||activeNum===2">
                            <div class="title-box">
                                <div class="title-name title-active">公告资讯</div>
                                <div class="title-more" v-if="briefList&&briefList.length>8">更多>></div>
                            </div>
                            <div class="brief-container" v-if="briefList&&briefList.length>0">
                                <div class="brief-carousel">
                                    <el-carousel interval="4000">
                                        <el-carousel-item @click="goDetail(item)" v-for="item in briefList.slice(0,8)" :key="item">
                                            <img class="brief-img" :src="item.cover" alt />
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                                <div class="brief-list">
                                    <div class="brief-item" @click="goDetail(item)" v-for="item in briefList.slice(0,8)" :key="item">
                                        <div class="brief-title">【工作简报】{{item.title}}</div>
                                        <div class="brief-time">{{timestampToTime(item.createTime) }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="briefList&&briefList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>
                        </div>
                        <!--成果展示-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">成果展示</div>
                                <div class="title-more" @click="changeActiveNum(3)" v-if="achieveList&&achieveList.length>4" >更多>></div>
                            </div>
                            <div class="achieve-list">
                                <div class="achieve-item" v-for="item in achieveList.slice(0,4)" :key="item" @click="goDetail(item)" >
                                    <div class="achieve-cover">
                                        <img class="img-100" :src="item.cover" alt />
                                    </div>
                                    <div class="achieve-type-title">
                                        <div class="achieve-name">{{item.title}}</div>
                                    </div>
                                </div>
                                <data-empty v-if="achieveList&&achieveList.length===0" title="暂无成果"/>
                            </div>
                        </div>

                        <div class="right-item-container" v-if="activeNum===3">
                            <div class="title-box">
                                <div class="title-name title-active">成果展示</div>
                            </div>
                            <div class="achieve-list">
                                <div class="achieve-item" v-for="item in achieveList" :key="item" @click="goDetail(item)" >
                                    <div class="achieve-cover">
                                        <img class="img-100" :src="item.cover" alt />
                                    </div>
                                    <div class="achieve-type-title">
                                        <div class="achieve-name">{{item.title}}</div>
                                    </div>
                                </div>
                                <data-empty v-if="achieveList&&achieveList.length===0" title="暂无成果"/>
                            </div>
                        </div>

                        <!--教师文章-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">教师文章</div>
                                <div class="title-more" @click="changeActiveNum(4)" v-if="articleList&&articleList.length>8">更多>></div>
                            </div>
                            <div class="article-list" v-if="articleList&&articleList.length>0">
                                <div class="article-item" v-for="item in articleList.slice(0,8)" :key="item" @click="goDetail(item)">
                                    <div class="article-title">{{ item.title }}</div>
                                    <div class="article-user">{{ item.trueName }}</div>
                                    <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                                    <div class="article-view">
                                        <img class="article-view-img"  alt src="../../assets/icon/img/eye_new.png">
                                        <p>{{item.readNum }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="articleList&&articleList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>
                        </div>

                        <div class="right-item-container" v-if="activeNum===4">
                            <div class="title-box">
                                <div class="title-name title-active">教师文章</div>
                            </div>
                            <div class="article-list" v-if="articleList&&articleList.length>0">
                                <div class="article-item" v-for="item in articleList" :key="item" @click="goDetail(item)">
                                    <div class="article-title">{{ item.title }}</div>
                                    <div class="article-user">{{ item.trueName }}</div>
                                    <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                                    <div class="article-view">
                                        <img class="article-view-img" alt src="../../assets/icon/img/eye_new.png">
                                        <p>{{item.readNum }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="articleList&&articleList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>
                        </div>
                        <!--高水平示范课-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">高水平示范课</div>
                                <div class="title-more" @click="changeActiveNum(5)" v-if="courseList&&courseList.length>4">更多>></div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in courseList.slice(0,4)" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="courseList&&courseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>

                        <div class="right-item-container" v-if="activeNum===5">
                            <div class="title-box">
                                <div class="title-name title-active">高水平示范课</div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in courseList" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="courseList&&courseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>
                        <!--区本课程-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">区本课程</div>
                                <div class="title-more" @click="changeActiveNum(7)" v-if="qbCourseList&&qbCourseList.length>1">更多>></div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in qbCourseList.slice(0,4)" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="qbCourseList&&qbCourseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>
                        <div class="right-item-container" v-if="activeNum===7">
                            <div class="title-box">
                                <div class="title-name title-active">区本课程</div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in qbCourseList" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="qbCourseList&&qbCourseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>
                        <!--校本课程-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">校本课程</div>
                                <div class="title-more" @click="changeActiveNum(8)" v-if="xbCourseList&&xbCourseList.length>4">更多>></div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in xbCourseList.slice(0,4)" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="xbCourseList&&xbCourseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>
                        <div class="right-item-container" v-if="activeNum===8">
                            <div class="title-box">
                                <div class="title-name title-active">校本课程</div>
                            </div>
                            <div class="course-list-box">
                                <div class="course-item" v-for="item in xbCourseList" :key="item" @click="viewCourse(item)">
                                    <div class="course-one">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-name">{{item.courseName}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="xbCourseList&&xbCourseList.length===0">
                                <dataEmpty title="暂无课程" />
                            </div>
                        </div>
                        <!--工作日志-->
                        <div class="right-item-container" v-if="activeNum===0">
                            <div class="title-box">
                                <div class="title-name title-active">工作日志</div>
                                <div class="title-more" @click="changeActiveNum(6)" v-if="logList&&logList.length>8">更多>></div>
                            </div>
                            <div class="article-list" v-if="logList&&logList.length>0">
                                <div class="article-item" v-for="item in logList.slice(0,8)" :key="item" @click="goDetail(item)">
                                    <div class="article-title">{{ item.title }}</div>
                                    <div class="article-user">{{ item.trueName }}</div>
                                    <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                                    <div class="article-view">
                                        <img class="article-view-img" alt src="../../assets/icon/img/eye_new.png">
                                        <p>{{item.readNum }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="logList&&logList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>
                        </div>

                        <div class="right-item-container" v-if="activeNum===6">
                            <div class="title-box">
                                <div class="title-name title-active">工作日志</div>
                            </div>
                            <div class="article-list" v-if="logList&&logList.length>0">
                                <div class="article-item" v-for="item in logList" :key="item" @click="goDetail(item)">
                                    <div class="article-title">{{ item.title }}</div>
                                    <div class="article-user">{{ item.trueName }}</div>
                                    <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                                    <div class="article-view">
                                        <img class="article-view-img" alt src="../../assets/icon/img/eye_new.png">
                                        <p>{{item.readNum }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="logList&&logList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import { queryDict } from "@/api/admin/public";
import { studioCareOrCancel,infoStudio,listStudioActive } from "@/api/admin/studio";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "studioInfo",
    components: {dataEmpty},
    data() {
        return {
            defaultImage:"https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/hy_logo.png",
            activeNum: 0,
            activeClass: {},
            timestampToTime,
            groupInfo: {},
            briefList:[],//工作简报
            achieveList:[],//成果
            articleList:[],//教师文章
            courseList:[],//高水平示范课
            qbCourseList:[],//区本课程
            xbCourseList:[],//校本课程
            memberList:[],
            logList:[],//工作日志
            isStudioPeopleList: false,
            studioPeopleList: [],
            studioTitle: '',
            groupId: '',
            studioClassifyList: [],
            studioList:[],
        };
    },
    created() {},
    mounted() {
        if (this.$route.query.groupId) {
            this.groupId = this.$route.query.groupId
            this.getInfoStudio();
        }
    },
    activated() {},
    watch: {},
    methods: {
        showDefaultImage(e){
            e.target.src = 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/hy_logo.png';
        },
        changeActiveNum(i) {
            this.studioClassifyList = [];
            this.activeClass = {};
            this.activeNum = i;
            var type = ''
            if (i === 2) {
                type = 1
            } else if (i === 3) {
                type = 3
            } else if (i === 4) {
                type = 2
            } else if (i === 6) {
                type = 4
            }
            if (type !== '') {
                queryDict({ code: 'studio_info_type_' + type }).then(res => {
                    this.studioClassifyList = res.data.data;
                })
            }

        },
        getQueryDict() {
            queryDict({ code: 'studio_info_type' }).then(res => {
                this.studioClassifyList = res.data.data;
            })
        },
        viewCourse(row) {
            this.$router.push({
                path: "/famousCourseLookVideo",
                query: {
                    courseId: row.courseId,
                    isLook: 1,
                    isStudioRoom: 1,
                    groupId: this.groupId,
                }
            });
        },
        goDetail(row) {
            this.$router.push({
                path: "/studioDetail",
                query: {
                    infoId: row.infoId,
                    isStudioRoom: 1,
                    groupId: this.groupId,
                }
            });
        },
        getStudioCareOrCancel() {
            studioCareOrCancel({ groupId: this.groupInfo.groupId }).then(res => {
                if (res.data.code === 1) {
                    if (this.groupInfo.isCare === 1) {
                        this.groupInfo.isCare = 0;
                        this.groupInfo.careNum--;
                    } else {
                        this.groupInfo.isCare = 1;
                        this.groupInfo.careNum++;
                    }
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        getInfoStudio() {
            infoStudio({ groupId: this.groupId }).then(res => {
                if (res.data.code === 1) {
                    this.groupInfo = res.data.data;
                    this.memberList = this.groupInfo.memberList
                    this.briefList = this.groupInfo.briefList;
                    this.achieveList = this.groupInfo.achieveList;
                    this.articleList = this.groupInfo.articleList
                    this.courseList = this.groupInfo.courseList;
                    this.qbCourseList = this.groupInfo.qbCourseList;
                    this.xbCourseList = this.groupInfo.xbCourseList;
                    this.logList = this.groupInfo.logList;
                    listStudioActive({ groupNature: this.groupInfo.groupNature }).then(res => {
                        this.studioList = res.data.data;
                    })
                }

            })
        },
        viewStudio(item) {
            this.$router.push({
                path: "/studioinfo",
                query: {groupId: item.groupId,}
            });
            this.groupId = item.groupId
            this.getInfoStudio()

        },
    }
};
</script>
<style scoped>

.studio-img-img{
    width: 96%;
    height: auto;
    max-height: 96%;
}

.top-container{
    width: 100%;
    padding:10px 5px 10px 10px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto!important;
}
.second-container{
    width: 100%;
    height: calc(100vh - 90px);
    //background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.div-100{
    width: 100%!important;
    height: auto;
}
/deep/ .el-scrollbar .el-scrollbar__wrap {
    border-top: none !important;
}
/*导航栏*/
.nav_container {
    width: 100%;
    height: 40px;
    background: #ff7f2e;
    margin-top: -10px;
}
.nav-box{
    width: 80%;
    height: 40px;
    margin: auto;
}
.nav-box ul{
    display: flex;
    width: auto;
    height: 40px!important;
    padding-inline-start: 0!important;
}
.nav-box ul li {
    position: relative;
    float: left;
    width: auto;
    text-align: center;
    line-height: 40px;
    list-style-type: none;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
}
.nav-box ul li a {
    color: #fff;
    display: block;
    cursor: pointer;
    font-size: 16px;
}
.nav-box ul li a:hover{
    color: #ffbf6b;
    font-weight: bold;
}
.is_active{
    font-weight: bold;
    color: #ffbf6b!important;
}
/*标题栏*/
.title-box100{
    display: flex;
    width: 100%;
    height: 100%;
    border-bottom: 2px solid #ff7f2e;
}
.title-name100{
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    //background-color: #cecece;
    cursor: pointer;
    text-indent: 10px;
}
.title-active100{
    color: #fff;
    background: #ff7f2e!important;
}
.title-box{
    display: flex;
    width: 100%;
    height: 34px;
    border-bottom: 2px solid #ff7f2e;
}
.title-name{
    width: auto;
    height: 34px;
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    //color: #fff;
    //background-color: #cecece;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    color: #ff7f2e;
}
.title-active{
    //color: #fff;
    //background: #ff7f2e!important;
}
.title-more{
    color: #666!important;
    font-size: 16px;
    height: 34px;
    line-height: 34px;
    margin-left: auto;
    padding-right: 10px;
    cursor: pointer;
}
.title-more:hover{
    color: #ff7f2e!important;
}
/*主要内容*/
.info-container{
    display: flex;
    width: 100%;
    height: auto;
    margin-top: 10px;

}
.left-container{
    width: 25%;
    background-color: #fff;
}
.studio-stats-container{
    width: 100%;
    height: auto;
}
.studio-info{
    display: flex;
    width: 90%;
    height: 80px;
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #cecece;
}
.studio-img{
    width: 28%;
    height: 100%!important;
    img{
        width: 96%;
        height: auto;
        max-height: 96%;
    }
}
.studio-name-care{
    width: 72%;
    height: 100%!important;
    padding-left: 10px;
    box-sizing: border-box;
}
.studio-name{
    width: 100%;
    height: 28px;
    line-height: 28px;
    color: #ff7f2e;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.studio-care-btn{
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    width: auto;
    border-radius: 5px;
    margin: 2% 0;
    display: inline-block;
    padding: 0 10px;
    background: #f48d28;
    color: #fff;
    text-align: center;
    cursor: pointer;
}
.studio-care-num{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #333333;
    font-size: 16px;
    span{
        color: #f48d28;
    }
}
.studio-stats{
    display: flex;
    width: 90%;
    height: 50px;
    margin: auto;
    border-bottom: 1px dashed #cecece;
    padding-bottom: 10px;
}
.status-item{
    width: 20%;
    height: 50px;
    cursor: pointer;
}
.status-item-num{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
}
.text1{
    color: rgba(56,148,255);
}
.text2{
    color: rgba(226,149,17);
}
.text3{
    color: rgba(173,31,211);
}
.text4{
    color: rgba(202,213,7);
}
.text5{
    color: rgba(226,149,17);
}
.status-item-name{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #666;
    font-size: 1.1vw;
}
/*关注度排行*/
.studio-recommend-container{
    width: 100%;
    height: auto;
    margin-top: 10px;
}
.studio-care-list{
    width: 90%;
    height: 100%;
    margin: auto;
}
.studio-care-rank{
    display: flex;
    border-bottom: 1px dashed #cecece;
    cursor: pointer;
    margin: auto;
}
.group-active-index{
    width: 36px;
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    padding-left: 5px;
    box-sizing: border-box;
}
.group-active-name{
    line-height: 36px;
    font-size: 16px;
    width: calc(100% - 120px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-active-care{
    width: 80px;
    line-height: 36px;
    text-align: right;
    color: #cecece!important;
    font-size: 16px;
}
#num1, #num2, #num3, #num4, #num5, #num6, #num7, #num8, #num9, #num10 {
    background: none !important;
    font-size: 20px;
    font-weight: bold
}
#num1 {
    color: #ed574a;
}
#num2 {
    color: #f8b551;
}
#num3 {
    color: #32b16c;
}
#num4, #num5, #num6,#num7, #num8, #num9, #num10 {
    color: #86c8ff;
}
.right-container{
    width: 74%;
    margin-left: 1%;
}
.right-content{
    width: 100%;
    height: 100%;
}
.right-item-container{
    width: 100%;
    padding-bottom: 10px;
    box-sizing: border-box;
    height: auto;
    background-color: #fff;
    margin-bottom: 10px;
}

.studio-intro{
    width: 100%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    text-indent: 30px;
    font-size: 16px;
    line-height: 30px;
}
/*工作简报*/
.brief-container{
    display: flex;
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.brief-carousel{
    width: 45%;
    height: 100%;
}
/deep/ .el-carousel{
    width: 100%;
    height: 240px;
}
/deep/ .el-carousel .el-carousel-item{
    width: 100%;
    height: 100%;
}
/deep/ .el-carousel .el-carousel-item img{
    width: 100%;
    height: 100%;
}
/*指示器按钮*/
/deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    border: none;
    border-radius: 50%;
    background-color: grey;
}
.brief-img{
    width: 100%!important;
    height: 240px;
    cursor: pointer;
}
.brief-list{
    width: 55%;
    height: 100%;
    padding-left: 10px;
    box-sizing: border-box;
}
.brief-item{
    display: flex;
    width: 100%;
    height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px dashed #cecece;
    cursor: pointer;
}
.brief-title{
    height: 30px;
    width: calc(100% - 140px);
    line-height: 30px;
    font-size: 16px;
    color: #ff7f2e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.brief-time{
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #666;
    font-size: 15px;
}
/*成果*/
.achieve-list{
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    align-items: center;
}
.achieve-item{
    width: 25%!important;
    height: 180px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 140px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-type-title{
    display: flex;
    height: 30px;
    width: 100%;
}
.achieve-name{
    height: 30px;
    line-height: 30px;
    width: 100%;
    color: #ff7f2e;
    font-size: 16px;
    text-align: left;
    //font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*教师文章*/
.article-list{
    background-color: #FFFFFF;
    width: 100%;
    height: auto;
    align-items: center;
    margin-top: 10px;
}
.article-item{
    display: flex;
    width: 100%;
    height: 30px;
    padding-left: 10px;
    //padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px dashed #cecece;
}
.article-title{
    height: 30px;
    line-height: 30px;
    width: calc(100% - 300px);
    font-size: 16px;
    color: #ff7f2e;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.article-user{
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #666;
    font-size: 16px;
    text-align: center;
}
.article-time{
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #666;
    font-size: 16px;
    text-align: center;
}
.article-view{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 80px;
    height: 30px;
    color: #ff7f2e;
    font-size: 16px;
    padding-right: 10px;
    box-sizing: border-box;
}
.article-view-img{
    width: 20px;
    height: 20px;
    margin-right: 3px;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 10px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 25%!important;
    height: 170px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-one{
    width: 100%;
    height: 140px;
    border: 1px solid #cecece;
    border-radius: 4px;
    box-sizing: border-box;
}
.course-cover{
    width: 100%;
    height: 100%;
    img{
        width: 100%;
        height: 100%;
    }
}
.course-name{
    height: 30px;
    font-size: 16px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 30px;
}
/*成员*/
.studio-member{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 10px;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
}
.member-item{
    width: 20%!important;
    height: 140px;
    box-sizing: border-box;
    cursor: pointer;
}
.member-head{
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 50px;
    img{
        width: 100%;
        height: 100%;
        //border-radius: 50px;
    }
}
.member-name-role{
    display: flex;
    width: 100px;
    height: 30px;
    margin: auto;
}
.member-role{
    width: 50px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    margin-top: 3px;
    text-align: center;
}
.member-name{
    width: 50%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #333333;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>